/**
 * ConsolidateIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const ConsolidateIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M21.153 16.304a3.86 3.86 0 0 0-2.122-1.358V11.02h-6.05V9.07a3.93 3.93 0 0 0 2.122-1.374q.846-1.045.846-2.432 0-1.655-1.146-2.81Q13.657 1.302 12 1.3q-1.657 0-2.803 1.153Q8.05 3.608 8.05 5.27q0 1.384.846 2.428a3.94 3.94 0 0 0 2.123 1.372v1.951H4.97v3.926q-1.277.315-2.123 1.358T2 18.751q0 1.65 1.15 2.8t2.8 1.15q1.655 0 2.809-1.15t1.154-2.8q0-1.402-.847-2.447a3.86 3.86 0 0 0-2.122-1.358V12.98h10.112v1.966q-1.276.315-2.122 1.358-.847 1.044-.847 2.447 0 1.65 1.15 2.8t2.8 1.15q1.655 0 2.809-1.15T22 18.75q0-1.402-.847-2.447m-13.79 1.039q.576.581.576 1.408 0 .828-.581 1.402a1.93 1.93 0 0 1-1.409.574 1.9 1.9 0 0 1-1.401-.58 1.92 1.92 0 0 1-.574-1.406q0-.827.579-1.403a1.92 1.92 0 0 1 1.406-.576q.828 0 1.404.581m4.632-10.104a1.9 1.9 0 0 1-1.407-.58 1.92 1.92 0 0 1-.577-1.405 1.9 1.9 0 0 1 .582-1.404 1.93 1.93 0 0 1 1.412-.576q.83 0 1.407.581.577.58.577 1.409 0 .827-.582 1.4a1.94 1.94 0 0 1-1.412.575m7.45 12.914a1.93 1.93 0 0 1-1.409.574 1.9 1.9 0 0 1-1.4-.58 1.92 1.92 0 0 1-.575-1.406q0-.827.58-1.403a1.92 1.92 0 0 1 1.405-.576q.828 0 1.404.581t.576 1.408-.581 1.402" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const ConsolidateIcon = makeIcon('ConsolidateIcon', ConsolidateIconSvg)
